export default __webpack_public_path__ + "static/media/TeamSnap-Multi-Sport-Banner-Display.9a9c8dd9.png";